/* Accessible, on-demand image previews for blog articles. */
(() => {
  'use strict';
  if (window.ivonneArticleImagePreview) return;
  window.ivonneArticleImagePreview = true;
  let dialog;
  function largeSource(img) {
    const url = new URL(img.currentSrc || img.src, location.href);
    if (url.hostname === 'cdn.shopify.com' || (url.origin === location.origin && url.pathname.startsWith('/cdn/shop/'))) {
      url.searchParams.set('width', '2400');
      url.searchParams.delete('height');
      url.searchParams.delete('crop');
    }
    return url.href;
  }
  function getDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.id = 'ArticleImagePreview';
    dialog.className = 'article-image-preview';
    dialog.setAttribute('aria-label', 'Vergrote afbeelding');
    dialog.innerHTML = '<div class="article-image-preview-header"><span>Afbeeldingspreview</span><a target="_blank" rel="noopener" class="article-image-original">Open origineel</a><button type="button" class="icon-button" aria-label="Afbeelding sluiten">×</button></div><div class="article-image-preview-stage"><img alt=""></div>';
    document.body.append(dialog);
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      dialog._opener?.focus({ preventScroll: true });
      dialog.querySelector('img').removeAttribute('src');
    });
    return dialog;
  }
  function enhance(scope = document) {
    scope.querySelectorAll('.warm-article .article-hero, .warm-article-body img').forEach(img => {
      // Preserve links already provided by the author, including product links.
      if (img.closest('a,button')) return;
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'article-image-trigger';
      trigger.setAttribute('aria-label', 'Vergroot afbeelding' + (img.alt ? ': ' + img.alt : ''));
      trigger.title = 'Klik om te vergroten';
      img.before(trigger);
      trigger.append(img);
      trigger.addEventListener('click', () => {
        if (document.querySelector('dialog[open]')) return;
        const preview = getDialog();
        preview._opener = trigger;
        const photo = preview.querySelector('img');
        photo.alt = img.alt || 'Vergrote blogafbeelding';
        photo.src = largeSource(img);
        preview.querySelector('.article-image-original').href = photo.src;
        preview.showModal();
        preview.querySelector('button').focus();
      });
    });
  }
  enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
